export const theme = {
    token: {
        colorPrimary: '#0b1437',
        colorPrimaryBorder: '#e9ecef',
        fontFamily: "'Outfit', 'DM Sans', Helvetica, Arial, sans-serif",
    },
    components: {        
        Switch: {
            handleBg: '#f4f5fa',
            trackHeight: 30,
            trackMinWidth: 64,
            innerMaxMargin: 30,
            handleSize: 26,
        },
        Tabs: {
            horizontalMargin: "0 0 0 20px",
            cardGutter: 4,
            cardBg: 'rgba(255,255,255,0.7)',
            colorBorder: 'rgba(255,255,255,0)',
            itemColor: '#6c00f3',
            inkBarColor: '#2f1871',
        },
        Radio: {
            dotSize: 10,
            radioSize: 24,
        },
        Form:{
            verticalLabelPadding: "0 0 2px",
        },
        Modal: {
            contentBg: '#edf2f7aa',
            headerBg: '#edf2f700',
            footerBg: '#edf2f700',
        } 
      },
};
